// extracted by mini-css-extract-plugin
export default {"full-page":"GenericLayout_full-page__sw0We","content":"GenericLayout_content__KaJmf"};